//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "CategoryCollectionsTitle",
  components: {
    Section: () => import("@/components/common/Section"),
    TopTitleComponent: () => import("@/components/common/TopTitleComponent"),
  },
  computed: {
    ...mapGetters({
      title: 'pages/category-collections/title',
    })
  }
}
